import type { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export const spaceTypes: SpaceTypeEnum[] = [
  'wheelchair',
  'wheelchair xl',
  'stretcher',
  'stretcher xl',
  'ambulatory',
  'broda chair',
  'geri chair',
  'delivery',
];
